import ApiRequest, {
  logicAppApiRequest,
  logicAppQueryPath,
  // ApiRequestAzure,
} from '../common/configurations/AxiosConfiguration';

const headers = {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
};

const dataHeaders = {
  headers: {
    Accept: '*/*',
    // 'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
  },
};

const formDataHeaders = {
  headers: {
    Accept: '*/*',
    'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
  },
};

function getRevisionParamaterHeader(type) {
  return {
    fileName: 'REVISION_PARAMETER',
    fileAction: type,
  };
}
function uploadRevisionPrameterFile(dataToUpload, fileName, userEmail) {
  const header = {
    headers: getRevisionParamaterHeader('UPLOAD'),
  };
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading paramters file: ${error}`);
      return Promise.reject();
    });
}

function getRevisionPrameterFile() {
  const data = '@';
  const header = {
    headers: getRevisionParamaterHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading paramters file: ${error}`);
      return Promise.reject();
    });
}

function getAllOpenMaintenanceTickets() {
  try {
    return ApiRequest.get('/maintenance-ticket/all-open', headers);
  } catch (e) {
    console.log(`Error when getting all open maintenance tickets : ${e}`);
    return e;
  }
}
function getAllPlannedPrediction() {
  try {
    return ApiRequest.get('/plannedprediction/all', headers);
  } catch (e) {
    console.log(`Error when getting all planned prediction : ${e}`);
    return e;
  }
}

function getAllClosedMaintenanceTickets() {
  try {
    return ApiRequest.get('/maintenance-ticket/all-close', headers);
  } catch (e) {
    console.log(`Error when getting all closed maintenance tickets : ${e}`);
    return e;
  }
}

function getAllMaintenanceTickets() {
  try {
    return ApiRequest.get('/maintenance-ticket/all', headers);
  } catch (e) {
    console.log(`Error when getting all maintenance tickets : ${e}`);
    return e;
  }
}
function getAllActualWorkshops() {
  try {
    return ApiRequest.get('/workshops/all', headers);
  } catch (e) {
    console.log(`Error when getting all actual workshops : ${e}`);
    return e;
  }
}

const addNewActualWorkshops = (newWorkshopName) => {
  return ApiRequest.post(
    `/workshops/addAll`,
    [
      {
        workshopsName: newWorkshopName,
      },
    ],
    dataHeaders,
  ).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(
          'Validation error detected while adding in ActualWorkshop screen',
        );
        return Promise.reject(error.response.data);
      }
    }
    console.log(`Error while adding Actual Workshop: ${error}`);
    return Promise.reject();
  });
};

const removeActualWorkshop = (workshopName) => {
  return ApiRequest.post(
    `/workshops/removeAll`,
    [
      {
        workshopsName: workshopName,
      },
    ],
    dataHeaders,
  ).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(
          'Validation error detected while removing in ActualWorkshop screen',
        );
        return Promise.reject(error.response.data);
      }
    }
    console.log(`Error while removing Actual Workshop: ${error}`);
    return Promise.reject();
  });
};

function getAllGroups() {
  try {
    return ApiRequest.get('/groups/all', headers);
  } catch (e) {
    console.log(`Error when getting all groups : ${e}`);
    return e;
  }
}
function getTicketDetails(ticketNumber) {
  try {
    return ApiRequest.get(
      `/maintenance-ticket/ticket/${ticketNumber}`,
      headers,
    );
  } catch (e) {
    console.log(`Error when getting ticket : ${e}`);
    return e;
  }
}
function getHistoric(ticketNumber) {
  try {
    return ApiRequest.get(
      `/maintenance-ticket/historic/${ticketNumber}`,
      headers,
    );
  } catch (e) {
    console.log(`Error when getting historic : ${e}`);
    return e;
  }
}
function getTicketByWagonNumber(wagonNumber) {
  return ApiRequest.get(
    `/maintenance-ticket/wagon/${wagonNumber}`,
    headers,
  ).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(` ticket with wagon number ${wagonNumber} is invalid `);
        return Promise.reject(error.response.data);
      }
      if (error.response.status === 404) {
        console.log(
          ` ticket with wagon number ${wagonNumber} not found ${error.response.status} `,
        );
        return Promise.resolve(error.response.data);
      }
    }
    console.log(`Error when getting ticket by wagon number: ${error}`);
    return Promise.reject();
  });
}
function getAllDamageCodes() {
  return ApiRequest.get(`/damages-gcu/all`, headers).catch((error) => {
    console.log(`Error when getting damage codes: ${error}`);
    return Promise.reject();
  });
}
function createTicket(ticket) {
  return ApiRequest.post(
    `/maintenance-ticket/create`,
    ticket,
    formDataHeaders,
  ).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(`validation errors detected on ticket`);
        return Promise.reject(error.response.data);
      }
    }
    console.log(`Error when creating ticket: ${error}`);
    return Promise.reject();
  });
}
function updateTicket(ticket) {
  return ApiRequest.put(
    `/maintenance-ticket/update`,
    ticket,
    formDataHeaders,
  ).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(`validation errors detected on ticket`);
        return Promise.reject(error.response.data);
      }
    }
    console.log(`Error when updating ticket: ${error}`);
    return Promise.reject();
  });
}
function getAttachment(ticketNumber, anomalyIndex, filename) {
  return ApiRequest.get(
    `/attachment/ticket/${ticketNumber}/${anomalyIndex}/${filename}`,
    headers,
  ).catch((error) => {
    console.log(`Error when downloading attachment: ${error}`);
    return Promise.reject();
  });
}
function deleteAttachment(ticketNumber, anomalyIndex, filename) {
  return ApiRequest.delete(
    `/attachment/ticket/${ticketNumber}/${anomalyIndex}/${filename}`,
    headers,
  ).catch((error) => {
    console.log(`Error when deleting attachment: ${error}`);
    return Promise.reject();
  });
}
function getLatestNotifications() {
  return ApiRequest.get(`/notification/latest`, headers).catch((error) => {
    console.log(`Error when getting notifications: ${error}`);
    return Promise.reject();
  });
}
function getAllWagonNumbers() {
  return ApiRequest.get(`/wagon-number/all`, headers).catch((error) => {
    console.log(`Error when getting wagon number list: ${error}`);
    return Promise.reject();
  });
}
function getWagonTechnicalDetailsWithHistoric(wagonNumber) {
  return ApiRequest.get(
    `/wagon-technical-details/${wagonNumber}`,
    headers,
  ).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(
          `Wagon Number ${wagonNumber} is invalid ${error.response.status}`,
        );
        return Promise.reject(error.response.data);
      }
      if (error.response.status === 404) {
        console.log(
          `Wagon Number ${wagonNumber} is not registered ${error.response.status}`,
        );
        return Promise.reject(error.response.data);
      }
    }
    console.log(
      `Error when getting wagon technical details with historic: ${error}`,
    );
    return Promise.reject();
  });
}

function getUserInfo() {
  return ApiRequest.get(`/user-info`, headers).catch((error) => {
    console.log(`Error when getting user informations: ${error}`);
    return Promise.reject();
  });
}

function getFormattedMailTemplate(ticketNumber) {
  return ApiRequest.get(`ticket/email/${ticketNumber}`, headers).catch(
    (error) => {
      console.log(`Error when getting email template: ${error}`);
      return Promise.reject();
    },
  );
}

function sendEmail(emailFormData) {
  return ApiRequest.post(
    `/ticket/send-email`,
    emailFormData,
    formDataHeaders,
  ).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(`Validation errors detected on email`);
        return Promise.reject(error.response.data);
      }
    }
    console.log(`Error when creating email: ${error}`);
    return Promise.reject();
  });
}

function autoSendEmail(ticketNumber) {
  return ApiRequest.post(
    `/ticket/send-email-auto/${ticketNumber}`,
    headers,
  ).catch((error) => {
    console.log(`Error when creating email: ${error}`);
    return Promise.reject();
  });
}

function saveUserPreference(view) {
  return ApiRequest.post(`/user-preference/create`, view, headers).catch(
    (error) => {
      console.log(`Error when saving view: ${error}`);
      return Promise.reject();
    },
  );
}

function getUserPreferences() {
  return ApiRequest.get(`/user-preference/all`, headers).catch((error) => {
    console.log(`Error when getting user preferences: ${error}`);
    return Promise.reject();
  });
}

function deleteUserPreference(viewName) {
  return ApiRequest.delete(
    `/user-preference/delete/${viewName}`,
    headers,
  ).catch((error) => {
    console.log(`Error when deleting user preference ${viewName}: ${error}`);
    return Promise.reject();
  });
}
function downloadTicketsToExcel() {
  return ApiRequest.get(`/maintenance-ticket/download`, headers).catch(
    (error) => {
      console.log(
        `Error when downloading maintenance tickets to excel file: ${error}`,
      );
      return Promise.reject();
    },
  );
}
function filterNotificationsByBusinessUnits(businessUnits) {
  return ApiRequest.post(`/notification/filter`, businessUnits, headers).catch(
    (error) => {
      console.log(
        `Error when filtering notifications by business units: ${error}`,
      );
      return Promise.reject();
    },
  );
}
function importInvoicesFromExcel(invoice) {
  return ApiRequest.post(`/invoice/import`, invoice, headers).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(`Validation errors detected while importing excel file`);
        return Promise.reject(error.response.data);
      }
    }
    console.log(`Error when importing invoices from excel file: ${error}`);
    return Promise.reject();
  });
}

function matchInvoicesWithTickets(invoices) {
  return ApiRequest.post(`/invoice/match`, invoices, headers).catch((error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log(
          `Validation errors detected while matching invoices with ticket`,
        );
        return Promise.reject(error.response.data);
      }
    }
    console.log(`Error when matching invoices with tickets: ${error}`);
    return Promise.reject();
  });
}
function saveInvoices(invoices) {
  return ApiRequest.post(`/invoice/create`, invoices, formDataHeaders).catch(
    (error) => {
      if (error.response) {
        if (error.response.status === 400) {
          console.log(`Validation errors detected while saving invoices`);
          return Promise.reject(error.response.data);
        }
      }
      console.log(`Error when saving invoices: ${error}`);
      return Promise.reject();
    },
  );
}

function getAllTicketsForWagonList(wagonNumberList) {
  return ApiRequest.post(`/wagon/tickets`, wagonNumberList, headers).catch(
    (error) => {
      console.log(`Error when getting tickets for wagons: ${error}`);
      return Promise.reject();
    },
  );
}
function downloadInvoiceTemplate() {
  return ApiRequest.get(`/invoice/template`, headers).catch((error) => {
    console.log(`Error when getting invoice template: ${error}`);
    return Promise.reject();
  });
}
function searchInvoicesByQueries(queries) {
  return ApiRequest.get(`/invoice/search${queries}`, headers).catch((error) => {
    console.log(`Error when searching invoices by queries: ${error}`);
    return Promise.reject();
  });
}
function getAllSuppliers() {
  return ApiRequest.get(`/invoice/suppliers`, headers).catch((error) => {
    console.log(`Error when searching suppliers by queries: ${error}`);
    return Promise.reject();
  });
}
function downloadInvoice(invoiceNumber, invoiceDate) {
  return ApiRequest.get(
    `/invoice/download/${invoiceNumber}/${invoiceDate}`,
    headers,
  ).catch((error) => {
    console.log(`Error when getting invoice attachment: ${error}`);
    return Promise.reject();
  });
}
function updateInvoices(invoices) {
  return ApiRequest.post(`/invoice/update`, invoices, formDataHeaders).catch(
    (error) => {
      if (error.response) {
        if (error.response.status === 400) {
          console.log(`Validation errors detected while updating invoices`);
          return Promise.reject(error.response.data);
        }
      }
      console.log(`Error when updating invoices: ${error}`);
      return Promise.reject();
    },
  );
}
function validateCSVFiles(files) {
  return ApiRequest.post(
    `/wagon-availability/file-validation`,
    files,
    formDataHeaders,
  ).catch((error) => {
    console.log(`Error when validating files for wagon simulation : ${error}`);
    return Promise.reject();
  });
}
function triggerDataModel(validationResult) {
  return ApiRequest.post(
    `/wagon-availability/trigger`,
    validationResult,
    headers,
  ).catch((error) => {
    console.log(`Error when triggering data model : ${error}`);
    return Promise.reject();
  });
}
function findAllPlannedMaintenancesWentToWorkshop() {
  return ApiRequest.get(`contract/commitment`, headers).catch((error) => {
    console.log(
      `Error when getting planned maintenances went to workshop: ${error}`,
    );
    return Promise.reject();
  });
}
function downloadWorkshopTimeToExcel() {
  return ApiRequest.get(`/contract/download`, headers).catch((error) => {
    console.log(`Error when downloading workshop time to excel file: ${error}`);
    return Promise.reject();
  });
}
function deleteStatus(ticketNumber, historic) {
  return ApiRequest.post(
    `/maintenance-ticket/status/${ticketNumber}`,
    historic,
    headers,
  ).catch((error) => {
    console.log(`Error when deleting status: ${error}`);
    return Promise.reject();
  });
}
function getAllDamagePlaces() {
  return ApiRequest.get(`/damage-place/all`, headers).catch((error) => {
    console.log(`Error when getting damage places: ${error}`);
    return Promise.reject();
  });
}
function triggerSandboxMail() {
  return ApiRequest.post(`/wagon-availability/send-email`, headers).catch(
    (error) => {
      console.log(`Error when triggering sandbox mail: ${error}`);
      return Promise.reject();
    },
  );
}

const getParameterArPageHeader = (type) => {
  return {
    fileName: 'AR_PARAMETER',
    fileAction: type,
  };
};

const uploadParameterArPageFile = (dataToUpload, fileName, userEmail) => {
  const header = {
    headers: getParameterArPageHeader('UPLOAD'),
  };
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading parameters file: ${error}`);
      return Promise.reject();
    });
};

const getParameterArPageFile = () => {
  const data = '@';
  const header = {
    headers: getParameterArPageHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading AR parameter file: ${error}`);
      return Promise.reject();
    });
};

const getBusinessNeedHeader = (type) => {
  return {
    fileName: 'BUSINESS_NEED',
    fileAction: type,
  };
};

const uploadBusinessNeedPageFile = (dataToUpload, fileName, userEmail) => {
  const header = {
    headers: getBusinessNeedHeader('UPLOAD'),
  };
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading business need file: ${error}`);
      return Promise.reject();
    });
};

const getBusinessNeedPageFile = () => {
  const data = '@';
  const header = {
    headers: getBusinessNeedHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading business need file: ${error}`);
      return Promise.reject();
    });
};

const getDurationParameterHeader = (type) => {
  return {
    fileName: 'DURATION_PARAMETER',
    fileAction: type,
  };
};

const uploadDurationParameterPageFile = (dataToUpload, fileName, userEmail) => {
  const header = {
    headers: getDurationParameterHeader('UPLOAD'),
  };
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading template : ${error}`);
      return Promise.reject();
    });
};

const getDurationParameterPageFile = () => {
  const data = '@';
  const header = {
    headers: getDurationParameterHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading template: ${error}`);
      return Promise.reject();
    });
};

const getParametersScrapingHeader = (type) => {
  return {
    fileName: 'SCRAPING_PARAMETER',
    fileAction: type,
  };
};

const uploadParametersScrapingFile = (dataToUpload, fileName, userEmail) => {
  const header = {
    headers: getParametersScrapingHeader('UPLOAD'),
  };
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading parameter scraping: ${error}`);
      return Promise.reject();
    });
};

const getParametersScrapingFile = () => {
  const data = '@';
  const header = {
    headers: getParametersScrapingHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading parameter scraping: ${error}`);
      return Promise.reject();
    });
};

const getRevisionPlanUploadHeader = (type) => {
  return {
    fileName: 'REV_PLAN',
    fileAction: type,
  };
};

function uploadRevisionPlanUploadFile(dataToUpload, fileName, userEmail) {
  const header = {
    headers: getRevisionPlanUploadHeader('UPLOAD'),
  };
  console.log('headers', header);
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading Revision Plan : ${error}`);
      return Promise.reject();
    });
}

const getRevisionPlanUploadFile = () => {
  const data = '@';
  const header = {
    headers: getRevisionPlanUploadHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading Revision Plan: ${error}`);
      return Promise.reject();
    });
};

const getGcuDamageCodeHeader = (type) => {
  return {
    fileName: 'GCU_DAMAGE',
    fileAction: type,
  };
};

const uploadGcuDamageCodeFile = (dataToUpload, fileName, userEmail) => {
  const header = {
    headers: getGcuDamageCodeHeader('UPLOAD'),
  };
  console.log('headers', header);
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading GCU Damage Code : ${error}`);
      return Promise.reject();
    });
};

const getGcuDamageCodeFile = () => {
  const data = '@';
  const header = {
    headers: getGcuDamageCodeHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading GCU Damage Code : ${error}`);
      return Promise.reject();
    });
};

const getContactsEmailHeader = (type) => {
  return {
    fileName: 'CONTACT_EMAILS',
    fileAction: type,
  };
};

const uploadContactsEmailFile = (dataToUpload, fileName, userEmail) => {
  const header = {
    headers: getContactsEmailHeader('UPLOAD'),
  };
  console.log('headers', header);
  header.headers['Content-Type'] = 'application/octet-stream';
  header.headers.Accept = '*/*';
  header.headers.actFileName = fileName;
  header.headers.senderEmail = userEmail;
  return logicAppApiRequest
    .post(logicAppQueryPath, dataToUpload, header)
    .catch((error) => {
      console.log(`Error when uploading Contacts Email : ${error}`);
      return Promise.reject();
    });
};

const getContactsEmailFile = () => {
  const data = '@';
  const header = {
    headers: getContactsEmailHeader('DOWNLOAD'),
  };
  header.headers.actFileName = null;
  header.headers.senderEmail = null;
  console.log('headers', header);
  return logicAppApiRequest
    .post(logicAppQueryPath, data, header, { responseType: 'blob' })
    .catch((error) => {
      console.log(`Error when downloading Contacts Email : ${error}`);
      return Promise.reject();
    });
};

const ApiService = {
  getAllOpenMaintenanceTickets,
  getAllClosedMaintenanceTickets,
  getAllMaintenanceTickets,
  getAllActualWorkshops,
  getAllGroups,
  getTicketDetails,
  getHistoric,
  getTicketByWagonNumber,
  getAllDamageCodes,
  createTicket,
  updateTicket,
  getAttachment,
  deleteAttachment,
  getLatestNotifications,
  getAllWagonNumbers,
  getWagonTechnicalDetailsWithHistoric,
  getUserInfo,
  getFormattedMailTemplate,
  sendEmail,
  autoSendEmail,
  saveUserPreference,
  getUserPreferences,
  deleteUserPreference,
  downloadTicketsToExcel,
  filterNotificationsByBusinessUnits,
  importInvoicesFromExcel,
  matchInvoicesWithTickets,
  getAllTicketsForWagonList,
  saveInvoices,
  downloadInvoiceTemplate,
  searchInvoicesByQueries,
  downloadInvoice,
  updateInvoices,
  validateCSVFiles,
  triggerDataModel,
  findAllPlannedMaintenancesWentToWorkshop,
  downloadWorkshopTimeToExcel,
  deleteStatus,
  getAllDamagePlaces,
  triggerSandboxMail,
  getAllSuppliers,
  getRevisionPrameterFile,
  uploadRevisionPrameterFile,
  getAllPlannedPrediction,
  getParameterArPageFile,
  uploadParameterArPageFile,
  uploadBusinessNeedPageFile,
  getBusinessNeedPageFile,
  uploadParametersScrapingFile,
  getParametersScrapingFile,
  uploadRevisionPlanUploadFile,
  getRevisionPlanUploadFile,
  uploadDurationParameterPageFile,
  getDurationParameterPageFile,
  uploadGcuDamageCodeFile,
  getGcuDamageCodeFile,
  uploadContactsEmailFile,
  getContactsEmailFile,
  addNewActualWorkshops,
  removeActualWorkshop,
};
export default ApiService;
